module.exports = __webpack_public_path__ + "img/icon-kc.2db61168.png";